var map = {
	"./images/attack-1.png": 995,
	"./images/attack-2.png": 996,
	"./images/attack-3.png": 997,
	"./images/attack-5.png": 998,
	"./images/attack-number-0.png": 999,
	"./images/attack-number-1.png": 1000,
	"./images/attack-number-2.png": 1001,
	"./images/attack-number-3.png": 1002,
	"./images/attack-number-4.png": 1003,
	"./images/attack-number-5.png": 1004,
	"./images/attack-number-6.png": 1005,
	"./images/attack-number-7.png": 1006,
	"./images/attack-number-8.png": 1007,
	"./images/attack-number-9.png": 1008,
	"./images/attack.png": 1009,
	"./images/back.png": 1010,
	"./images/backgroud.jpg": 1011,
	"./images/blood-15.png": 1012,
	"./images/blood-3.png": 1013,
	"./images/blood-5.png": 1014,
	"./images/blood-7.png": 1015,
	"./images/deadly-15.png": 1016,
	"./images/deadly-3.png": 1017,
	"./images/deadly-5.png": 1018,
	"./images/deadly-7.png": 1019,
	"./images/default.png": 1020,
	"./images/fade01.png": 1021,
	"./images/fade02.png": 1022,
	"./images/fade03.png": 1023,
	"./images/fade04.png": 1024,
	"./images/frame-background.png": 1025,
	"./images/hit-blocked.png": 1026,
	"./images/hit-count.png": 1027,
	"./images/hit-double.png": 1028,
	"./images/hit-triple.png": 1029,
	"./images/in-number-0.png": 1030,
	"./images/in-number-1.png": 1031,
	"./images/in-number-2.png": 1032,
	"./images/in-number-3.png": 1033,
	"./images/in-number-4.png": 1034,
	"./images/in-number-5.png": 1035,
	"./images/in-number-6.png": 1036,
	"./images/in-number-7.png": 1037,
	"./images/in-number-8.png": 1038,
	"./images/in-number-9.png": 1039,
	"./images/magic_rule_background.jpg": 1040,
	"./images/magic_rule_not_pressed_button.png": 1041,
	"./images/magic_rule_pressed_button.png": 1042,
	"./images/magic_rule_star.png": 1043,
	"./images/mission-clear.png": 1044,
	"./images/mission-failed.png": 1045,
	"./images/next.png": 1046,
	"./images/number-item-0.png": 1047,
	"./images/number-item-1.png": 1048,
	"./images/number-item-2.png": 1049,
	"./images/number-item-3.png": 1050,
	"./images/number-item-4.png": 1051,
	"./images/number-item-5.png": 1052,
	"./images/number-item-6.png": 1053,
	"./images/number-item-7.png": 1054,
	"./images/number-item-8.png": 1055,
	"./images/number-item-9.png": 1056,
	"./images/player-movein.png": 1057,
	"./images/point-10.png": 1058,
	"./images/point-15.png": 1059,
	"./images/point-20.png": 1060,
	"./images/point-5.png": 1061,
	"./images/point-50.png": 1062,
	"./images/previous.png": 1063,
	"./images/protect-1.png": 1064,
	"./images/protect-2.png": 1065,
	"./images/protect-3.png": 1066,
	"./images/protect-5.png": 1067,
	"./images/red-number-0.png": 1068,
	"./images/red-number-1.png": 1069,
	"./images/red-number-2.png": 1070,
	"./images/red-number-3.png": 1071,
	"./images/red-number-4.png": 1072,
	"./images/red-number-5.png": 1073,
	"./images/red-number-6.png": 1074,
	"./images/red-number-7.png": 1075,
	"./images/red-number-8.png": 1076,
	"./images/red-number-9.png": 1077,
	"./images/shoot.png": 1078,
	"./images/stage.png": 1079,
	"./images/star-into.png": 1080,
	"./images/state-clear.png": 1081,
	"./images/state-clear_p9.png": 1082,
	"./images/total-power.png": 1083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 994;